import React from 'react';
import img from './Images/VR 1.png'

const Header = () => {
  return (
    <>
        <div className="header">
            <div className='text'>
                <h2>Micheal.A.Nwankwo</h2>
                <h2>XR Development</h2>
            </div>
            <img src={img} alt='Background' className='background-image'/>
            <div className='h1'>Portfolio</div>
        </div>
    </>
  )
}

export default Header;
